/**
 * Filtre disponibilité (API) + notices facettes / pagination (dates ≠ filtres Shopify).
 * Relancé après AJAX collection (Search & Discovery).
 *
 * Total catalogue : `#loven-collection-results-count` (data-server-count, masqué dans collection-grid).
 * Modale filtres : pied « Tout effacer » + CTA dynamique.
 */
(function () {
  'use strict';

  /** Si true, supprime le texte « (12) » après chaque libellé de facette (sidebar + filtres mobile). */
  var LOVEN_HIDE_SHOPIFY_FACET_COUNTS = true;

  var API_URL = 'https://igthraqyjiadzclkkixn.supabase.co/functions/v1/search-availability';

  /**
   * Même calendrier Bookingmood : https/http, www, app., slash final, query différente.
   * Tous les sous-domaines *.bookingmood.com sont ramenés à bookingmood.com + chemin.
   */
  function canonicalBookingmoodHost(hostname) {
    var h = (hostname || '').toLowerCase();
    if (h === 'bookingmood.com' || /\.bookingmood\.com$/.test(h)) return 'bookingmood.com';
    return h.replace(/^www\./, '');
  }

  function normalizeBookingmoodEmbedKey(raw) {
    var s = (raw || '').trim();
    if (!s) return '';
    try {
      var u = new URL(/^https?:\/\//i.test(s) ? s : 'https://' + s);
      var host = canonicalBookingmoodHost(u.hostname || '');
      var path = (u.pathname || '/').replace(/\/+$/, '');
      if (!path || path === '/') return host;
      return host + path;
    } catch (e) {
      return s.toLowerCase();
    }
  }

  /** Actif avec ?loven_availability_debug=1 ou ?loven_debug=1 ou ?loven_map_debug=1 — JSON brut de l’API en console uniquement. */
  function isLovenConsoleDebugForAvailability() {
    try {
      var s = window.location.search || '';
      return /\bloven_map_debug=1\b/.test(s) || /\bloven_debug=1\b/.test(s) || /\bloven_availability_debug=1\b/.test(s);
    } catch (e) {
      return false;
    }
  }

  /** ?loven_list_debug=1 : console.table du détail grille vs carte. */
  function isLovenListDebug() {
    try {
      return /\bloven_list_debug=1\b/.test(window.location.search || '') || isLovenConsoleDebugForAvailability();
    } catch (e) {
      return false;
    }
  }

  /**
   * Diagnostique écart API / cartes / marqueurs (même filtre `handle` + coords pour la carte).
   */
  function buildAvailabilityListDiagnostic(rows) {
    var table = [];
    var warnings = [];
    var nApi = (rows && rows.length) || 0;
    var inGrid = 0;
    var onMap = 0;
    for (var i = 0; i < nApi; i++) {
      var r0 = rows[i];
      if (!r0) continue;
      var r = normalizeAvailabilityRow(r0);
      var h = (r.handle || r.product_handle || '').trim();
      var hasH = !!h;
      var latN = r.latitude != null ? Number(r.latitude) : NaN;
      var lonN = r.longitude != null ? Number(r.longitude) : NaN;
      var hasCoords = isFinite(latN) && isFinite(lonN);
      if (hasH) inGrid++;
      if (hasH && hasCoords) onMap++;
      if (!hasH) {
        warnings.push({ type: 'sans_handle', index: i, id: r.id, title: rowProductTitle(r) });
      }
      if (hasH && !hasCoords) {
        warnings.push({ type: 'sans_coords_carte', handle: h, index: i });
      }
      table.push({
        index: i,
        handle: h || '—',
        id: r.id != null ? r.id : '',
        titre: rowProductTitle(r),
        distance_km: r.distance_km != null && r.distance_km !== '' ? Number(r.distance_km) : '',
        grilles: hasH ? 'oui' : 'non',
        marqueur: hasH && hasCoords ? 'oui' : 'non',
        lat: hasCoords ? latN : '',
        lon: hasCoords ? lonN : '',
      });
    }
    return {
      apiCount: nApi,
      inGrid: inGrid,
      onMap: onMap,
      table: table,
      warnings: warnings,
    };
  }

  function logAvailabilityListDiagnostic(rows) {
    var d = buildAvailabilityListDiagnostic(rows);
    console.info(
      '%c[Loven] Résultat API (grille = lignes avec handle — carte = handle + lat/lon valides)',
      'font-weight:bold',
      {
        lignesBrutes: d.apiCount,
        fichesGrille: d.inGrid,
        marqueursCarte: d.onMap,
        ecartGrilleCarte: d.inGrid - d.onMap,
      },
    );
    if (d.warnings.length) {
      console.warn('[Loven] Lignes incomplètes (expliquent écarts) : ' + d.warnings.length, d.warnings);
    }
    if (isLovenListDebug()) {
      try {
        console.table(d.table);
      } catch (e) {
        console.log(d.table);
      }
    } else {
      console.info('[Loven] Tableau détaillé: ajoutez &loven_list_debug=1 ou loven_debug=1 à l’URL.');
    }
  }

  function hasActiveFacetParams() {
    return window.location.search.indexOf('filter.') !== -1;
  }

  /* ------------------------------------------------------------------------
   * Facettes Shopify (filter.*) sur la grille API (search / tous-les-hebergements).
   * L'API search-availability ignore les facettes : on intersecte ses lignes avec les
   * handles renvoyés par Shopify via ?view=facets (templates/collection.facets.liquid,
   * templates/search.facets.liquid — paginate 250, plafond 12 pages = 3 000 fiches).
   * ---------------------------------------------------------------------- */
  var FACET_PAGE_CAP = 12;
  var facetHandlesCache = { key: null, promise: null };

  /** Paramètres qui déterminent l'ensemble Shopify : facettes + requête de recherche. */
  function facetParamsOnly() {
    var current = new URLSearchParams(window.location.search);
    var out = new URLSearchParams();
    current.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 || key === 'q' || key === 'type' || key === 'options[prefix]') {
        out.append(key, value);
      }
    });
    return out;
  }

  function facetCacheKey() {
    var entries = [];
    facetParamsOnly().forEach(function (value, key) {
      entries.push(key + '=' + value);
    });
    entries.sort();
    return window.location.pathname + '?' + entries.join('&');
  }

  function facetPageUrl(page) {
    var params = facetParamsOnly();
    params.set('view', 'facets');
    if (page > 1) params.set('page', String(page));
    return window.location.pathname + '?' + params.toString();
  }

  function fetchFacetPage(page) {
    return fetch(facetPageUrl(page), { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('facets ' + response.status);
      return response.json();
    });
  }

  /**
   * Résout { handles: {handle: true}, count, truncated } pour les facettes de l'URL courante,
   * ou null : pas de facette active, collection nommée (grille Shopify native), ou flux indisponible
   * (repli : grille API non filtrée + avertissement console). Jamais de boucle : page 1 puis
   * les pages 2..pages en parallèle, bornées par FACET_PAGE_CAP.
   */
  function loadFacetHandlesForCurrentUrl() {
    if (!hasActiveFacetParams() || isNamedCollectionCatalogPage()) return Promise.resolve(null);
    var key = facetCacheKey();
    if (facetHandlesCache.key === key && facetHandlesCache.promise) return facetHandlesCache.promise;

    var handles = {};
    function addAll(data) {
      var list = data && Array.isArray(data.handles) ? data.handles : [];
      list.forEach(function (h) {
        h = String(h || '')
          .trim()
          .toLowerCase();
        if (h) handles[h] = true;
      });
    }

    var promise = fetchFacetPage(1)
      .then(function (first) {
        addAll(first);
        var totalPages = Math.max(1, Number(first && first.pages) || 1);
        var pages = Math.min(FACET_PAGE_CAP, totalPages);
        var rest = [];
        for (var p = 2; p <= pages; p++) rest.push(fetchFacetPage(p).then(addAll));
        return Promise.all(rest).then(function () {
          return { handles: handles, count: Object.keys(handles).length, truncated: totalPages > FACET_PAGE_CAP };
        });
      })
      .catch(function (err) {
        /* Échec réseau / template absent : on ne mémorise pas, le prochain filtre réessaie. */
        if (facetHandlesCache.promise === promise) facetHandlesCache = { key: null, promise: null };
        try {
          console.warn(
            '[Loven] Facettes non appliquées à la grille API (?view=facets indisponible) :',
            err && err.message,
          );
        } catch (e) {}
        return null;
      });
    facetHandlesCache = { key: key, promise: promise };
    return promise;
  }

  function filterRowsByFacetHandles(rows, facetSet) {
    if (!facetSet || !facetSet.handles || !rows || !rows.length) return rows;
    return rows.filter(function (r) {
      var h = (r.handle || r.product_handle || '').trim().toLowerCase();
      return !!(h && facetSet.handles[h]);
    });
  }

  function formatCount(n) {
    return String(Math.max(0, Math.floor(n))).replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f');
  }

  /** Compteur au-dessus de la grille : hébergement(s) (ton tourisme / Love’nSpa). */
  function formatHeadingLine(n) {
    n = Math.max(0, Math.floor(Number(n)));
    if (n <= 0) return 'Aucun hébergement';
    if (n >= 1000) {
      var k = Math.floor(n / 1000) * 1000;
      return 'Plus de ' + formatCount(k) + ' hébergements';
    }
    return formatCount(n) + ' hébergement' + (n > 1 ? 's' : '');
  }

  function updateResultsCountHeading() {
    var wrap = document.getElementById('loven-collection-results-count');
    var dynWrap = document.getElementById('loven-dynamic-results-count');
    var chromeTitle = document.getElementById('loven-rooms-sheet-title');
    var title = wrap && wrap.querySelector('.loven-collection-results-count__title');
    var dynTitle = dynWrap && dynWrap.querySelector('.loven-collection-results-count__title');
    if (!wrap && !dynWrap && !chromeTitle) return;
    if (!title && !dynTitle && !chromeTitle) return;

    var params = new URLSearchParams(window.location.search);
    var hasDates = !!(params.get('start') && params.get('end'));
    var line = '';

    if (window.__lovenMapViewportFilterActive && typeof window.__lovenMapViewportVisible === 'number') {
      line = formatHeadingLine(window.__lovenMapViewportVisible);
    } else if (hasDates) {
      if (typeof window.__lovenAvailabilityVisible === 'number') {
        line = formatHeadingLine(window.__lovenAvailabilityVisible);
      } else {
        var sc = parseInt(
          (wrap && wrap.getAttribute('data-server-count')) ||
            (dynWrap && dynWrap.getAttribute('data-server-count')) ||
            '0',
          10,
        );
        line = sc > 0 ? formatHeadingLine(sc) : '';
      }
    } else {
      if (window.__lovenDynamicAvailabilityMode && typeof window.__lovenAvailabilityVisible === 'number') {
        line = formatHeadingLine(window.__lovenAvailabilityVisible);
      } else {
        var pDest = new URLSearchParams(window.location.search);
        if (pDest.get('dest_lat') && pDest.get('dest_lon') && typeof window.__lovenGeoMarkerCount === 'number') {
          line = formatHeadingLine(window.__lovenGeoMarkerCount);
        } else if (pDest.get('dest_lat') && pDest.get('dest_lon') && typeof window.__lovenGeoVisible === 'number') {
          line = formatHeadingLine(window.__lovenGeoVisible);
        } else {
          /* Sans dates : le total catalogue vient du serveur (data-server-count).
             Compter le DOM ferait croire qu’il n’y a que 100 logements (taille de page). */
          var totalNoDates = parseInt(
            (wrap && wrap.getAttribute('data-server-count')) ||
              (dynWrap && dynWrap.getAttribute('data-server-count')) ||
              '0',
            10,
          );
          if (totalNoDates > 0) {
            line = formatHeadingLine(totalNoDates);
          } else {
            var n = countGridProducts();
            line = n > 0 ? formatHeadingLine(n) : '';
          }
        }
      }
    }

    function applyLine(el, tEl) {
      if (!el || !tEl) return;
      tEl.textContent = line;
      el.hidden = !line;
      if (line) {
        el.removeAttribute('aria-hidden');
      } else {
        el.setAttribute('aria-hidden', 'true');
      }
      el.classList.toggle('loven-collection-results-count--empty', !line);
    }

    applyLine(wrap, title);
    applyLine(dynWrap, dynTitle);
    if (chromeTitle) {
      chromeTitle.textContent = line;
      var chrome = document.getElementById('loven-rooms-sheet-chrome');
      if (chrome) {
        chrome.classList.toggle('loven-rooms-sheet-chrome--empty', !line);
      }
    }
    var noMatch = !line || line === 'Aucun hébergement';
    document.querySelectorAll('[data-loven-filters-empty]').forEach(function (el) {
      el.hidden = !(noMatch && hasActiveFacetParams());
    });
  }

  window.LovenUpdateCollectionResultsCount = updateResultsCountHeading;

  /** Conserve uniquement start/end (même collection). */
  function getResetFiltersUrl() {
    var u = new URL(window.location.href);
    var keep = ['start', 'end', 'dest_lat', 'dest_lon', 'dest_radius_km', 'dest_label', 'sort_by'];
    var next = new URLSearchParams();
    keep.forEach(function (key) {
      var value = u.searchParams.get(key);
      if (value) next.set(key, value);
    });
    var qs = next.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function countGridProducts() {
    return document.querySelectorAll('#CollectionAjaxContent .grid-product[data-product-id]').length;
  }

  function bindModalFooterOnce() {
    if (window.__lovenModalFooterBound) return;
    var clearBtn = document.getElementById('collection-filters-modal-clear');
    var cta = document.getElementById('collection-filters-modal-cta');
    if (!cta) return;
    window.__lovenModalFooterBound = true;

    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.href = getResetFiltersUrl();
      });
    }

    cta.addEventListener('click', function (e) {
      e.preventDefault();
      var params = new URLSearchParams(window.location.search);
      var hasDates = !!(params.get('start') && params.get('end'));
      var t = window.__lovenAvailabilityTotal;
      var v = window.__lovenAvailabilityVisible;

      if (hasDates && typeof t === 'number' && typeof v === 'number') {
        if (v === 0 && t > 0) {
          window.location.href = getResetFiltersUrl();
          return;
        }
      }

      if (typeof window.LovenCloseCollectionFiltersModal === 'function') {
        window.LovenCloseCollectionFiltersModal();
      }
    });
  }

  function syncFooterControls(total, visible, hasDates) {
    bindModalFooterOnce();
    var clearBtn = document.getElementById('collection-filters-modal-clear');
    var cta = document.getElementById('collection-filters-modal-cta');
    if (!cta) {
      updateResultsCountHeading();
      return;
    }

    var t = typeof total === 'number' ? total : 0;
    var v = typeof visible === 'number' ? visible : 0;
    var showClear = hasDates ? t > 0 && (hasActiveFacetParams() || (v === 0 && t > 0)) : hasActiveFacetParams();

    if (clearBtn) clearBtn.hidden = !showClear;
    var footer = document.getElementById('collection-filters-modal-footer');
    if (footer) footer.classList.toggle('collection-filters-modal__footer--cta-only', !showClear);

    if (!hasDates) {
      if (window.__lovenDynamicAvailabilityMode && typeof v === 'number' && v >= 0) {
        cta.disabled = false;
        if (v > 0) {
          cta.textContent =
            v >= 1000
              ? 'Afficher plus de ' + formatCount(Math.floor(v / 1000) * 1000) + ' hébergements'
              : 'Afficher ' + formatCount(v) + ' hébergement' + (v > 1 ? 's' : '');
        } else {
          cta.textContent = 'Fermer';
        }
        updateResultsCountHeading();
        return;
      }
      var wrapForFooter = document.getElementById('loven-collection-results-count');
      var totalFooter = wrapForFooter ? parseInt(wrapForFooter.getAttribute('data-server-count') || '0', 10) : 0;
      var n = totalFooter > 0 ? totalFooter : countGridProducts();
      cta.disabled = false;
      if (n > 0) {
        cta.textContent =
          n >= 1000
            ? 'Afficher plus de ' + formatCount(Math.floor(n / 1000) * 1000) + ' hébergements'
            : 'Afficher ' + formatCount(n) + ' hébergement' + (n > 1 ? 's' : '');
      } else {
        cta.textContent = 'Afficher les résultats';
      }
      updateResultsCountHeading();
      return;
    }

    cta.disabled = false;
    if (v > 0) {
      cta.textContent =
        v >= 1000
          ? 'Afficher plus de ' + formatCount(Math.floor(v / 1000) * 1000) + ' hébergements'
          : 'Afficher ' + formatCount(v) + ' hébergement' + (v > 1 ? 's' : '');
    } else if (v === 0 && t > 0) {
      cta.textContent = 'Voir tous les hébergements disponibles';
    } else {
      cta.textContent = 'Fermer';
    }
    updateResultsCountHeading();
  }

  function syncModalFooterAvailability(total, visible) {
    bindModalFooterOnce();
    var params = new URLSearchParams(window.location.search);
    var hasDates = !!(params.get('start') && params.get('end'));
    var tt = typeof total === 'number' ? total : 0;
    var vv = typeof visible === 'number' ? visible : 0;
    if (hasDates) {
      syncFooterControls(tt, vv, true);
    } else if (window.__lovenDynamicAvailabilityMode) {
      syncFooterControls(tt, vv, false);
    } else {
      syncFooterControls(0, 0, false);
    }
  }

  window.LovenUpdateFilterModalFooter = function () {
    var params = new URLSearchParams(window.location.search);
    var hasDates = !!(params.get('start') && params.get('end'));
    if (!hasDates) {
      if (
        window.__lovenDynamicAvailabilityMode &&
        typeof window.__lovenAvailabilityTotal === 'number' &&
        typeof window.__lovenAvailabilityVisible === 'number'
      ) {
        syncModalFooterAvailability(window.__lovenAvailabilityTotal, window.__lovenAvailabilityVisible);
      } else {
        syncFooterControls(undefined, undefined, false);
      }
    } else if (
      typeof window.__lovenAvailabilityTotal === 'number' &&
      typeof window.__lovenAvailabilityVisible === 'number'
    ) {
      syncModalFooterAvailability(window.__lovenAvailabilityTotal, window.__lovenAvailabilityVisible);
    } else {
      syncFooterControls(0, 0, true);
    }
  };

  /**
   * Le thème rend : <span class="tag__text">Label</span> (42)
   * On enlève les nœuds texte qui ne sont que « (nombre) ».
   */
  function hideCollectionFacetCounts() {
    if (!LOVEN_HIDE_SHOPIFY_FACET_COUNTS) return;
    var roots = document.querySelectorAll('#CollectionSidebar, #CollectionInlineFilterWrap');
    roots.forEach(function (root) {
      root.querySelectorAll('.tag__checkbox-wrapper .tag__text').forEach(function (textEl) {
        var node = textEl.nextSibling;
        while (node) {
          var next = node.nextSibling;
          if (node.nodeType === Node.TEXT_NODE) {
            if (/^\s*\(\d[\d\s]*\)\s*$/.test(node.textContent)) {
              node.remove();
            }
          }
          node = next;
        }
      });
    });
  }

  window.LovenHideCollectionFacetCounts = hideCollectionFacetCounts;

  function removePreviousUi() {
    document.querySelectorAll('.collection-availability-filter-banner').forEach(function (el) {
      el.remove();
    });
    document.querySelectorAll('.loven-facet-counts-notice').forEach(function (el) {
      el.remove();
    });
    document.querySelectorAll('.loven-pagination-dates-notice').forEach(function (el) {
      el.remove();
    });
    removeAvailabilityDebugPanel();
    document.body.classList.remove('loven-collection-dates-active');
  }

  function removeAvailabilityDebugPanel() {
    var el = document.getElementById('loven-availability-debug-panel');
    if (el) el.remove();
  }

  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /** Évite `.trim()` sur un nombre / objet (erreur silencieuse ou exception). */
  function strTrimLoose(v) {
    if (v == null || v === '') return '';
    if (typeof v === 'object') return '';
    return String(v).trim();
  }

  /**
   * Lit une clé lieu sur la ligne puis sur `location`, `product`, `meta` si présents.
   */
  function pickLocationField(r, keys) {
    if (!r || typeof r !== 'object') return '';
    var buckets = [r, r.location, r.product, r.meta, r.attributes, r.fields];
    var bi;
    var i;
    var k;
    var s;
    for (bi = 0; bi < buckets.length; bi++) {
      var obj = buckets[bi];
      if (!obj || typeof obj !== 'object' || Array.isArray(obj)) continue;
      for (i = 0; i < keys.length; i++) {
        k = keys[i];
        if (Object.prototype.hasOwnProperty.call(obj, k)) {
          s = strTrimLoose(obj[k]);
          if (s) return s;
        }
      }
    }
    return '';
  }

  function shopRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function syntheticRowId(i) {
    return 'dyn-' + i;
  }

  function clearDynamicAvailability() {
    window.__lovenDynamicAvailabilityMode = false;
    window.__lovenCatalogMapFromApi = false;
    var root = document.getElementById('CollectionAjaxResult');
    if (root) root.classList.remove('loven-dynamic-availability-mode');
    var dyn = document.getElementById('loven-dynamic-availability');
    if (dyn) {
      dyn.innerHTML = '';
      dyn.hidden = true;
    }
  }

  /** Aligné sur collection-map.js — dest_lat = latitude WGS84, dest_lon = longitude WGS84. */
  function readDestSearchFromUrl() {
    try {
      var p = new URLSearchParams(window.location.search);
      var la = p.get('dest_lat');
      var lo = p.get('dest_lon');
      if (!la || !lo) return null;
      var plat = parseFloat(la, 10);
      var plng = parseFloat(lo, 10);
      if (isNaN(plat) || isNaN(plng)) return null;
      var fb =
        typeof window.__lovenReadDestRadiusFallbackKm === 'function' ? window.__lovenReadDestRadiusFallbackKm() : 50;
      var r = parseFloat(p.get('dest_radius_km') || String(fb), 10);
      if (isNaN(r) || r <= 0) r = fb;
      if (r === 80) r = 50;
      r = Math.min(500, Math.max(5, r));
      return { lat: plat, lng: plng, radiusKm: r };
    } catch (e) {
      return null;
    }
  }

  function haversineKm(lat1, lon1, lat2, lon2) {
    var R = 6371;
    function toRad(d) {
      return (d * Math.PI) / 180;
    }
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * R * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  /**
   * Filtre côté client : même sémantique que l’URL (WGS84).
   * dest_lat ↔ latitude (produit), dest_lon ↔ longitude (produit).
   */
  function filterAvailabilityRowsByDestRadius(rows) {
    var dest = readDestSearchFromUrl();
    if (!dest || !rows || !rows.length) return rows;
    return rows.filter(function (r) {
      if (!r || r.latitude == null || r.longitude == null) return false;
      var latP = Number(r.latitude);
      var lonP = Number(r.longitude);
      if (isNaN(latP) || isNaN(lonP)) return false;
      var d = haversineKm(dest.lat, dest.lng, latP, lonP);
      return d <= dest.radiusKm;
    });
  }

  function getCollectionHandleFromPath() {
    var m = (window.location.pathname || '').match(/\/collections\/([^/?#]+)/i);
    return m ? String(m[1] || '').toLowerCase() : '';
  }

  /** /collections/<handle> hors search et catalogue global. */
  function isNamedCollectionCatalogPage() {
    if (!document.body || !document.body.classList.contains('template-collection')) return false;
    var handle = getCollectionHandleFromPath();
    return !!(handle && handle !== 'search' && handle !== 'tous-les-hebergements');
  }

  /** Handles produits rendus par Shopify dans la grille statique (page courante). */
  function getStaticCollectionProductHandles() {
    var handles = {};
    document
      .querySelectorAll('#CollectionAjaxContent .loven-static-collection-grid .grid-product[data-product-handle]')
      .forEach(function (card) {
        var h = (card.getAttribute('data-product-handle') || '').trim().toLowerCase();
        if (h) handles[h] = true;
      });
    return handles;
  }

  /**
   * Réaffiche toute la grille statique Shopify (collections nommées : avec ou sans Bookingmood).
   */
  function restoreStaticCollectionGrid() {
    var shown = 0;
    document
      .querySelectorAll('#CollectionAjaxContent .loven-static-collection-grid .grid-product[data-product-id]')
      .forEach(function (card) {
        card.classList.remove('loven-map-hidden');
        if (card.classList.contains('loven-geo-hidden')) {
          card.style.display = 'none';
          return;
        }
        card.classList.remove('loven-no-bookingmood');
        card.style.removeProperty('display');
        shown++;
      });
    window.__lovenMapViewportFilterActive = false;
    window.__lovenMapViewportVisible = undefined;
    window.__lovenAvailabilityVisible = shown;
    return shown;
  }

  /** Catalogue Shopify intégral sur /collections/<handle> (hors search et tous-les-hebergements). */
  function runNamedCollectionCatalogBrowse() {
    removePreviousUi();
    removeAvailabilityDebugPanel();
    clearDynamicAvailability();
    window.__lovenCatalogMapFromApi = false;
    window.__lovenZoneCollectionGeoBrowse = false;
    window.__lovenAvailabilityTotal = undefined;
    window.__lovenAvailabilityApiRows = undefined;
    window.__lovenAvailabilityApiEnvelope = undefined;
    window.__lovenAvailabilityByEmbedKey = undefined;
    restoreStaticCollectionGrid();
    if (typeof window.LovenClearMapViewportGridFilter === 'function') {
      window.LovenClearMapViewportGridFilter();
    }
    if (typeof window.LovenCollectionDestFilterRun === 'function') {
      window.LovenCollectionDestFilterRun();
    }
    if (typeof window.LovenUpdateFilterModalFooter === 'function') {
      window.LovenUpdateFilterModalFooter();
    } else {
      updateResultsCountHeading();
    }
    document.dispatchEvent(new CustomEvent('collection:mapSync'));
    if (typeof window.LovenBoostSponsoredGrid === 'function') {
      requestAnimationFrame(function () {
        window.LovenBoostSponsoredGrid({ force: true });
      });
    }
  }

  /** Filtre dispo (dates) sur la grille statique ; les fiches sans Bookingmood restent visibles sur les collections nommées. */
  function applyAvailabilityFilterToStaticGrid(uniqueUrls) {
    var shown = 0;
    var namedCatalog = isNamedCollectionCatalogPage();
    document
      .querySelectorAll('#CollectionAjaxContent .loven-static-collection-grid .grid-product[data-product-id]')
      .forEach(function (card) {
        if (card.classList.contains('loven-geo-hidden')) {
          card.style.display = 'none';
          return;
        }
        var embedUrl = (card.getAttribute('data-bookingmood-embed-url') || '').trim();
        if (!embedUrl) {
          if (namedCatalog) {
            card.classList.remove('loven-no-bookingmood');
            card.style.removeProperty('display');
            shown++;
            return;
          }
          card.style.display = 'none';
          card.classList.add('loven-no-bookingmood');
          return;
        }
        var embedKey = normalizeBookingmoodEmbedKey(embedUrl);
        if (!uniqueUrls[embedKey]) {
          card.style.display = 'none';
        } else {
          card.classList.remove('loven-no-bookingmood');
          card.style.removeProperty('display');
          shown++;
        }
      });
    window.__lovenAvailabilityVisible = shown;
    return shown;
  }

  /**
   * Chargement collection zone : ne garder que les logements du catalogue Shopify courant
   * (évite d’afficher des hébergements hors collection après le filtre geo API).
   */
  function filterRowsToZoneCollectionCatalog(rows, requestKind) {
    if (requestKind !== 'geo' || !isZoneCollectionGeoBrowse() || !rows || !rows.length) return rows;
    var handles = getStaticCollectionProductHandles();
    var keys = Object.keys(handles);
    if (!keys.length) return rows;
    return rows.filter(function (r) {
      var h = (r.handle || r.product_handle || '').trim().toLowerCase();
      return !!(h && handles[h]);
    });
  }

  function readZoneCollectionRadiusKm() {
    var root = document.getElementById('collection-map-root');
    var type = normalizeCollectionMapType(root ? root.dataset.collectionType : '');
    return Math.min(500, Math.max(5, radiusKmFromCollectionMapType(type)));
  }

  function normalizeCollectionMapType(raw) {
    var t = String(raw || '')
      .toLowerCase()
      .trim();
    if (!t) return 'default';
    if (t.indexOf('ville') !== -1 || t === 'city') return 'city';
    if (t.indexOf('depart') !== -1 || t.indexOf('départ') !== -1) return 'department';
    if (t.indexOf('reg') !== -1 || t === 'region') return 'region';
    if (t.indexOf('equip') !== -1 || t.indexOf('équip') !== -1) return 'wide';
    return 'default';
  }

  function radiusKmFromCollectionMapType(type) {
    var w = window.__lovenDestRadius || {};
    function numOr(x, d) {
      var n = Number(x);
      return isNaN(n) || n <= 0 ? d : n;
    }
    var p = {
      city: numOr(w.cityKm, 50),
      village: numOr(w.villageKm, 40),
      department: numOr(w.departmentKm, 90),
      region: numOr(w.regionKm, 180),
      country: numOr(w.countryKm, 500),
      defaultKm: numOr(w.defaultKm, 50),
    };
    if (type === 'city') return p.city;
    if (type === 'department') return p.department;
    if (type === 'region') return p.region;
    if (type === 'wide') return p.country;
    return p.defaultKm;
  }

  function getZoneCollectionInitialGeoState() {
    if (!isZoneCollectionGeoBrowse()) return null;
    var body = buildZoneCollectionGeoBody();
    return {
      lat: body.dest_lat,
      lng: body.dest_lon,
      radiusKm: body.dest_radius_km,
    };
  }

  /** Collections « catalogue » sans filtre : charger tous les pins carte via l’API (grille Shopify inchangée). */
  function isCatalogMapBrowseCollection() {
    if (!document.body || !document.body.classList.contains('template-collection')) return false;
    var handle = getCollectionHandleFromPath();
    if (handle !== 'search' && handle !== 'tous-les-hebergements') return false;
    var p = new URLSearchParams(window.location.search);
    if (p.get('start') && p.get('end')) return false;
    if (p.get('dest_lat') && p.get('dest_lon')) return false;
    return true;
  }

  /**
   * Collections zone (ex. /collections/bretagne) : filtre geo API au chargement
   * (comme /collections/search?dest_*) + élargissement au pan / dézoom carte.
   */
  function isZoneCollectionGeoBrowse() {
    if (!document.body || !document.body.classList.contains('template-collection')) return false;
    var handle = getCollectionHandleFromPath();
    if (!handle || handle === 'search' || handle === 'tous-les-hebergements') return false;
    var p = new URLSearchParams(window.location.search);
    if (p.get('start') && p.get('end')) return false;
    if (p.get('dest_lat') && p.get('dest_lon')) return false;
    var root = document.getElementById('collection-map-root');
    if (!root || root.dataset.centerLat == null || root.dataset.centerLng == null) return false;
    return true;
  }

  /**
   * data-center-lat / data-center-lng (Liquid Accentuate) ne sont pas toujours WGS84 :
   * parfois lat réelle sur center-lng, parfois l’inverse. On déduit lat/lon pour l’API.
   */
  function mapDataCenterAttrsToWgs84(centerLatAttr, centerLngAttr) {
    var fallback = { lat: 46.227638, lon: 2.227638 };
    var a = parseFloat(centerLatAttr, 10);
    var b = parseFloat(centerLngAttr, 10);
    if (isNaN(a) || isNaN(b)) return fallback;
    function isFranceLat(v) {
      return v >= 41 && v <= 51.5;
    }
    function isFranceLon(v) {
      return v >= -5.5 && v <= 9.5;
    }
    if (isFranceLat(a) && isFranceLon(b)) return { lat: a, lon: b };
    if (isFranceLat(b) && isFranceLon(a)) return { lat: b, lon: a };
    return fallback;
  }

  /** Carte catalogue sans filtre : API geo (Bookingmood), pas la pagination produits Shopify. */
  function buildCatalogMapGeoBody() {
    var root = document.getElementById('collection-map-root');
    var wgs = mapDataCenterAttrsToWgs84(root ? root.dataset.centerLat : null, root ? root.dataset.centerLng : null);
    return { dest_lat: wgs.lat, dest_lon: wgs.lon, dest_radius_km: 500 };
  }

  /** Rayon geo autour du centre collection (aligné recherche destination Bretagne, etc.). */
  function buildZoneCollectionGeoBody() {
    var root = document.getElementById('collection-map-root');
    var wgs = mapDataCenterAttrsToWgs84(root ? root.dataset.centerLat : null, root ? root.dataset.centerLng : null);
    var body = {
      dest_lat: wgs.lat,
      dest_lon: wgs.lon,
      dest_radius_km: readZoneCollectionRadiusKm(),
    };
    var handle = getCollectionHandleFromPath();
    if (handle) body.collection_handle = handle;
    return body;
  }

  /**
   * Rayon (km) englobant le viewport carte — plafond France entière (500 km).
   */
  function radiusKmFromLeafletMap(map) {
    if (!map || !map.getCenter || !map.getBounds) return 50;
    var center = map.getCenter();
    var bounds = map.getBounds();
    if (!center || !bounds) return 50;
    var sw = bounds.getSouthWest();
    var ne = bounds.getNorthEast();
    if (!sw || !ne) return 50;
    var spanLat = Math.abs(ne.lat - sw.lat);
    var spanLng = Math.abs(ne.lng - sw.lng);
    if (spanLat > 8 || spanLng > 10) return 500;
    var corners = [sw, ne];
    if (typeof L !== 'undefined' && L.latLng) {
      corners.push(L.latLng(sw.lat, ne.lng), L.latLng(ne.lat, sw.lng));
    }
    var maxD = 0;
    var i;
    for (i = 0; i < corners.length; i++) {
      maxD = Math.max(maxD, haversineKm(center.lat, center.lng, corners[i].lat, corners[i].lng));
    }
    return Math.min(500, Math.max(15, Math.ceil(maxD * 1.15)));
  }

  function rememberMapActiveGeoFromBody(body) {
    if (!body || body.dest_radius_km == null) return;
    window.__lovenMapActiveGeoRadiusKm = Number(body.dest_radius_km);
    if (body.dest_lat != null && body.dest_lon != null) {
      window.__lovenMapActiveGeoCenter = {
        lat: Number(body.dest_lat),
        lng: Number(body.dest_lon),
      };
    }
  }

  function canExpandGeoDataViaApi() {
    if (isNamedCollectionCatalogPage()) return false;
    if (isZoneCollectionGeoBrowse()) return true;
    var payload = buildSearchAvailabilityRequestPayload();
    return !!(payload && (payload.kind === 'geo' || payload.kind === 'availability'));
  }

  function buildMapViewportAvailabilityPayload(map) {
    if (!map || !map.getCenter) return null;
    var center = map.getCenter();
    var p = new URLSearchParams(window.location.search);
    var start = p.get('start');
    var end = p.get('end');
    var body = {
      dest_lat: center.lat,
      dest_lon: center.lng,
      dest_radius_km: radiusKmFromLeafletMap(map),
    };
    if (start && end) {
      body.start = start;
      body.end = end;
      return { kind: 'availability', body: body };
    }
    return { kind: 'geo', body: body };
  }

  function shouldExpandGeoFetchForMapBody(body) {
    if (!body || body.dest_radius_km == null) return false;
    var needed = Number(body.dest_radius_km);
    if (isNaN(needed)) return false;
    var active = window.__lovenMapActiveGeoRadiusKm;
    if (active == null || isNaN(Number(active))) {
      var dest = readDestSearchFromUrl();
      if (dest) {
        active = dest.radiusKm;
      } else {
        var zoneGeo = getZoneCollectionInitialGeoState();
        active = zoneGeo ? zoneGeo.radiusKm : 50;
      }
    } else {
      active = Number(active);
    }
    if (needed > active + 8) return true;
    var activeCenter = window.__lovenMapActiveGeoCenter;
    if (activeCenter && body.dest_lat != null && body.dest_lon != null) {
      var shift = haversineKm(activeCenter.lat, activeCenter.lng, Number(body.dest_lat), Number(body.dest_lon));
      if (shift > Math.max(25, active * 0.3)) return true;
    } else if (!activeCenter) {
      var zoneInit = getZoneCollectionInitialGeoState();
      if (
        zoneInit &&
        body.dest_lat != null &&
        body.dest_lon != null &&
        haversineKm(zoneInit.lat, zoneInit.lng, Number(body.dest_lat), Number(body.dest_lon)) >
          Math.max(25, zoneInit.radiusKm * 0.3)
      ) {
        return true;
      }
    }
    return false;
  }

  var mapViewportGeoFetchTimer = null;
  var mapViewportGeoFetchInFlight = false;

  /**
   * Élargit search-availability quand la carte dépasse le rayon de recherche initial
   * (ex. Lyon 50 km → dézoom France 500 km). Ne réduit pas le cache au zoom in.
   */
  window.LovenFetchAvailabilityForMapViewport = function (map) {
    return new Promise(function (resolve) {
      if (!map || mapViewportGeoFetchInFlight || !canExpandGeoDataViaApi()) {
        resolve(false);
        return;
      }
      var payload = buildMapViewportAvailabilityPayload(map);
      if (!payload || !shouldExpandGeoFetchForMapBody(payload.body)) {
        resolve(false);
        return;
      }

      clearTimeout(mapViewportGeoFetchTimer);
      mapViewportGeoFetchTimer = setTimeout(function () {
        var latest = buildMapViewportAvailabilityPayload(map);
        if (!latest || !shouldExpandGeoFetchForMapBody(latest.body)) {
          resolve(false);
          return;
        }
        mapViewportGeoFetchInFlight = true;
        var kind = latest.kind === 'availability' ? 'availability' : 'geo_map_expand';
        fetchSearchAvailabilityWithPayload(latest.body, kind)
          .then(function () {
            rememberMapActiveGeoFromBody(latest.body);
            if (
              typeof window.LovenRefetchPartnerCampaignsForGeo === 'function' &&
              !(typeof window.LovenIsZoneCollectionGeoBrowse === 'function' &&
                window.LovenIsZoneCollectionGeoBrowse())
            ) {
              window.LovenRefetchPartnerCampaignsForGeo(
                latest.body.dest_lat,
                latest.body.dest_lon,
                latest.body.dest_radius_km,
              );
            }
            resolve(true);
          })
          .catch(function () {
            resolve(false);
          })
          .then(function () {
            mapViewportGeoFetchInFlight = false;
          });
      }, 480);
    });
  };

  /**
   * Body POST search-availability : dates + geo, geo seul, carte catalogue, ou null.
   * { kind: 'availability' } | { kind: 'geo' } | { kind: 'catalog_map' } | null
   */
  function buildSearchAvailabilityRequestPayload() {
    var p = new URLSearchParams(window.location.search);
    var start = p.get('start');
    var end = p.get('end');
    var dest = readDestSearchFromUrl();
    if (start && end) {
      var b = { start: start, end: end };
      if (dest) {
        b.dest_lat = dest.lat;
        b.dest_lon = dest.lng;
        b.dest_radius_km = dest.radiusKm;
      }
      return { kind: 'availability', body: b };
    }
    if (dest) {
      return {
        kind: 'geo',
        body: { dest_lat: dest.lat, dest_lon: dest.lng, dest_radius_km: dest.radiusKm },
      };
    }
    if (isCatalogMapBrowseCollection()) {
      return { kind: 'catalog_map', body: buildCatalogMapGeoBody() };
    }
    if (isZoneCollectionGeoBrowse()) {
      return { kind: 'geo', body: buildZoneCollectionGeoBody() };
    }
    return null;
  }

  function shouldUseDynamicAvailability(envelope, rows) {
    if (!rows || !rows.length) return false;
    if (typeof envelope.enriched_count === 'number' && envelope.enriched_count > 0) return true;
    return rows.some(function (r) {
      return (
        r &&
        (r.id || r.handle || r.embed_url) &&
        (r.handle || r.embed_url || (r.latitude != null && r.longitude != null))
      );
    });
  }

  /**
   * Réponse search-availability : tableau attendu dans `available`, mais d’autres clés sont possibles.
   * `response` peut être l’objet métadonnées ou directement un tableau de produits.
   */
  function extractAvailabilityRowsFromPayload(data) {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (Array.isArray(data.response)) return data.response;
    if (data.response && typeof data.response === 'object') {
      var resp = data.response;
      if (Array.isArray(resp.available)) return resp.available;
      if (Array.isArray(resp.results)) return resp.results;
      if (Array.isArray(resp.products)) return resp.products;
      if (Array.isArray(resp.data)) return resp.data;
      if (Array.isArray(resp.items)) return resp.items;
      if (Array.isArray(resp.list)) return resp.list;
      if (Array.isArray(resp.accommodations)) return resp.accommodations;
      if (Array.isArray(resp.rows)) return resp.rows;
    }
    if (typeof data === 'object') {
      if (Array.isArray(data.available)) return data.available;
      if (Array.isArray(data.results)) return data.results;
      if (Array.isArray(data.products)) return data.products;
      if (Array.isArray(data.data)) return data.data;
      if (Array.isArray(data.items)) return data.items;
      if (Array.isArray(data.list)) return data.list;
      if (Array.isArray(data.accommodations)) return data.accommodations;
      if (Array.isArray(data.rows)) return data.rows;
    }
    return [];
  }

  /** Alias camelCase / lat-lon pour coller au JSON réel. */
  function normalizeAvailabilityRow(r) {
    if (!r || typeof r !== 'object') return r;
    var o = {};
    for (var k in r) {
      if (Object.prototype.hasOwnProperty.call(r, k)) o[k] = r[k];
    }
    if (o.region_collection == null && o.regionCollection != null) o.region_collection = o.regionCollection;
    if (o.ville_collection == null && o.villeCollection != null) o.ville_collection = o.villeCollection;
    if (o.departement == null && o.department != null) o.departement = o.department;
    if (o.departement == null && o.departement_name != null) o.departement = o.departement_name;
    if (o.departement == null && o.dept != null) o.departement = o.dept;
    if (o.handle == null && o.product_handle != null) o.handle = o.product_handle;
    if (o.handle == null && o.productHandle != null) o.handle = o.productHandle;
    if (o.latitude == null && o.lat != null) o.latitude = o.lat;
    if (o.longitude == null && o.lon != null) o.longitude = o.lon;
    if (o.longitude == null && o.lng != null) o.longitude = o.lng;
    if (o.image_url == null && o.imageUrl != null) o.image_url = o.imageUrl;
    /* API : region = synonyme de region_collection ; ville = synonyme de ville_collection */
    if (!strTrimLoose(o.region_collection) && strTrimLoose(o.region)) {
      o.region_collection = strTrimLoose(o.region);
    }
    if (!strTrimLoose(o.ville_collection) && strTrimLoose(o.ville)) {
      o.ville_collection = strTrimLoose(o.ville);
    }
    if (o.rating != null && o.rating !== '') {
      var rn = Number(o.rating);
      if (!isNaN(rn)) o.rating = rn;
    }
    if (o.rating_count == null && o.ratingCount != null) o.rating_count = o.ratingCount;
    if (o.rating_count == null && o.reviews_count != null) o.rating_count = o.reviews_count;
    if (o.rating_count == null && o.review_count != null) o.rating_count = o.review_count;
    if (o.rating_count != null && o.rating_count !== '') {
      var rc = parseInt(String(o.rating_count), 10);
      if (!isNaN(rc) && rc >= 0) o.rating_count = rc;
    }
    if (o.status == null && o.product_status != null) o.status = o.product_status;
    if (o.status == null && o.productStatus != null) o.status = o.productStatus;
    if (o.status == null && o.shopify_status != null) o.status = o.shopify_status;
    if (o.status == null && o.shopifyStatus != null) o.status = o.shopifyStatus;
    if (o.status == null && o.published_status != null) o.status = o.published_status;
    if (o.status == null && o.publishedStatus != null) o.status = o.publishedStatus;
    if (o.status == null && o.visibility != null) o.status = o.visibility;
    return o;
  }

  /**
   * N’afficher ni brouillon, ni archivé, ni non listé (aligné Shopify : draft / archived / unlisted).
   * Booléens possibles côté API (is_draft, archived, …) ; sinon champs `status` / `visibility`.
   */
  function isAvailabilityRowHiddenByProductStatus(r) {
    if (!r || typeof r !== 'object') return false;
    if (r.is_draft === true || r.isDraft === true) return true;
    if (r.draft === true) return true;
    if (r.archived === true || r.is_archived === true) return true;
    if (r.unlisted === true || r.is_unlisted === true) return true;
    var s = r.status != null && String(r.status).trim() !== '' ? String(r.status) : '';
    if (!s && r.product_status != null && String(r.product_status).trim() !== '') s = String(r.product_status);
    if (!s && r.productStatus != null && String(r.productStatus).trim() !== '') s = String(r.productStatus);
    if (!s && r.published_status != null && String(r.published_status).trim() !== '') s = String(r.published_status);
    if (!s && r.publishedStatus != null && String(r.publishedStatus).trim() !== '') s = String(r.publishedStatus);
    if (!s && r.visibility != null && String(r.visibility).trim() !== '') s = String(r.visibility);
    if (!s) return false;
    s = s.trim().toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
    return s === 'draft' || s === 'archived' || s === 'unlisted';
  }

  /** Métadonnées (enriched_count, etc.) : pas un tableau brut dans `response`. */
  function getAvailabilityEnvelope(data) {
    if (!data || typeof data !== 'object') return {};
    if (data.response && typeof data.response === 'object' && !Array.isArray(data.response)) {
      return data.response;
    }
    if (Array.isArray(data.response)) return data;
    return data;
  }

  /** Champs possibles renvoyés par search-availability (à aligner avec ton backend). */
  function getAvailabilityRowImageUrl(r) {
    if (!r || typeof r !== 'object') return '';
    var u = r.image_url || r.imageUrl || r.image || r.thumbnail || r.featured_image || r.featured_image_url || '';
    return String(u).trim();
  }

  /** Même libellé que snippets/price.liquid (À partir de … / nuit). */
  function formatPriceEurForGrid(n) {
    if (n == null || n === '') return '';
    var num = Number(n);
    if (isNaN(num)) return '';
    try {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 0,
      }).format(num);
    } catch (e) {
      return String(Math.round(num)) + '\u00a0€';
    }
  }

  /** Titre produit (API Shopify : title ; ancien format : name). */
  function rowProductTitle(r) {
    if (!r || typeof r !== 'object') return 'Logement';
    var t = (r.title || r.name || '').trim();
    return t || 'Logement';
  }

  /** Prix affiché : price, sinon price_min (comme la grille Shopify). */
  function rowDisplayPriceAmount(r) {
    if (!r || typeof r !== 'object') return null;
    if (r.price != null && r.price !== '') {
      var p = Number(r.price);
      if (!isNaN(p)) return p;
    }
    if (r.price_min != null && r.price_min !== '') {
      var pm = Number(r.price_min);
      if (!isNaN(pm)) return pm;
    }
    return null;
  }

  /** Note API (nombre 0–5 typiquement), après normalisation. */
  function rowRatingNumber(r) {
    if (!r || typeof r !== 'object' || r.rating == null || r.rating === '') return null;
    var n = Number(r.rating);
    if (isNaN(n)) return null;
    return n;
  }

  /** Nombre d’avis (search-availability : rating_count, etc.) */
  function rowRatingCount(r) {
    if (!r || typeof r !== 'object') return null;
    var v = r.rating_count;
    if (v == null || v === '') v = r.ratingCount;
    if (v == null || v === '') v = r.reviews_count;
    if (v == null || v === '') v = r.review_count;
    if (v == null || v === '') return null;
    var n = parseInt(String(v), 10);
    if (isNaN(n) || n < 0) return null;
    return n;
  }

  /** Ex. "15 avis" — vide si 0 / absent. */
  function formatRatingAvisCountHtml(r) {
    var c = rowRatingCount(r);
    if (c == null || c <= 0) return '';
    return (
      '<span class="loven-dyn-rating__count" aria-label="' +
      escapeHtml(String(c) + ' avis') +
      '">' +
      escapeHtml(String(c)) +
      ' avis</span>'
    );
  }

  /** 5 étoiles « vides » (☆) quand il n’y a pas encore d’avis. */
  function fiveEmptyStarsString() {
    return '\u2606\u2606\u2606\u2606\u2606';
  }

  /** Ligne lieu : ville uniquement (maquette carte). */
  function formatLocationLineHtml(r) {
    if (!r || typeof r !== 'object') return '';
    var ville = pickLocationField(r, [
      'ville_collection',
      'ville',
      'villeCollection',
      'ville_label',
      'ville_name',
      'city',
    ]);
    if (!ville) return '';
    return '<span class="loven-dyn-location__line">' + escapeHtml(ville) + '</span>';
  }

  // Le path du piment est defini une seule fois par document dans le sprite
  // (snippets/loven-pepper-sprite.liquid, rendu par layout/theme.liquid).
  // Les cartes construites ici ne referencent que le <symbol>.
  var LOVEN_PEPPER_SVG =
    '<svg fill="currentColor" aria-hidden="true" focusable="false"><use href="#loven-pepper"></use></svg>';

  var LOVEN_SPICYNESS_WORDS = ['', 'Romantique', 'Sensuel', 'Coquin', 'Pimenté', 'Averti'];

  function rememberSpicynessFromDom() {
    var map = window.__lovenSpicynessByHandle || {};
    document.querySelectorAll('.grid-product[data-product-handle][data-spicyness]').forEach(function (el) {
      var h = (el.getAttribute('data-product-handle') || '').trim();
      var n = parseInt(el.getAttribute('data-spicyness'), 10);
      if (h && n >= 1 && n <= 5) map[h] = n;
    });
    window.__lovenSpicynessByHandle = map;
    return map;
  }

  function parseSpicynessValue(raw) {
    if (raw == null || raw === '') return null;
    if (typeof raw === 'object') {
      if (raw.rating != null && raw.rating !== '') raw = raw.rating;
      else if (raw.value != null && raw.value !== '') raw = raw.value;
      else return null;
    }
    var n = Number(raw);
    if (isNaN(n)) return null;
    n = Math.round(n);
    if (n < 1 || n > 5) return null;
    return n;
  }

  function rowSpicynessLevel(r) {
    if (!r || typeof r !== 'object') return null;
    // Niveau 1-5 : champ spicy_level de la ligne si l'API le fournit, sinon
    // l'attribut data-spicyness posé en Liquid depuis custom.spicy_level.
    var fromRow = parseSpicynessValue(r.spicy_level);
    if (fromRow != null) return fromRow;
    var handle = (r.handle || '').trim();
    var map = window.__lovenSpicynessByHandle;
    if (handle && map && map[handle] != null) return map[handle];
    return null;
  }

  function formatSpicynessCardHtml(level) {
    if (level == null || level < 1) return '';
    var word = LOVEN_SPICYNESS_WORDS[level] || '';
    var icons = '';
    var i;
    for (i = 0; i < level; i++) {
      icons += '<span class="loven-spicyness__icon">' + LOVEN_PEPPER_SVG + '</span>';
    }
    return (
      '<div class="loven-spicyness loven-spicyness--card" role="img" aria-label="' +
      escapeHtml('Côté coquin : ' + level + ' sur 5, ' + word) +
      '"><span class="loven-spicyness__row"><span class="loven-spicyness__peppers" aria-hidden="true">' +
      icons +
      '</span><span class="loven-spicyness__word">' +
      escapeHtml(word) +
      '</span></span></div>'
    );
  }

  /** data-product-id : ID Shopify si présent, sinon dyn-i. */
  function rowProductDomId(r, idx) {
    if (r && r.id != null && String(r.id).trim() !== '') return String(r.id);
    return syntheticRowId(idx);
  }

  var LOVEN_SKELETON_CARD_COUNT = 12;

  /** Grille factice (alignée sur snippets/loven-collection-grid-skeleton.liquid) — évite d’afficher la grille catalogue avant la réponse API. */
  function renderAvailabilitySkeletonHtml() {
    var parts = [];
    parts.push(
      '<div class="collection-grid__wrapper loven-dyn-grid loven-dyn-grid--skeleton"><div id="loven-dynamic-results-count" class="loven-collection-results-count loven-collection-results-count--map-sheet" data-server-count="0" aria-live="polite" aria-busy="true"><span class="loven-collection-results-count__title" role="status">Chargement…</span></div>',
    );
    parts.push(
      '<div class="new-grid product-grid collection-grid" data-view="large" data-scroll-to aria-hidden="true">',
    );
    var i;
    for (i = 0; i < LOVEN_SKELETON_CARD_COUNT; i++) {
      parts.push(
        '<div class="grid-item grid-product loven-dyn-skeleton-card" aria-hidden="true"><div class="grid-item__content"><div class="grid-item__link" tabindex="-1"><div class="grid-product__image-wrap"><div class="grid__image-ratio grid__image-ratio--landscape"><div class="loven-dyn-grid__placeholder loven-dyn-skeleton-shimmer" aria-hidden="true"></div></div></div><div class="grid-item__meta"><div class="grid-item__meta-main"><div class="loven-dyn-skeleton-line loven-dyn-skeleton-line--loc loven-dyn-skeleton-shimmer"></div><div class="loven-dyn-skeleton-line loven-dyn-skeleton-line--title loven-dyn-skeleton-shimmer"></div><div class="loven-dyn-skeleton-line loven-dyn-skeleton-line--sub loven-dyn-skeleton-shimmer"></div></div></div></div></div></div>',
      );
    }
    parts.push('</div></div>');
    return parts.join('');
  }

  /** Si la page n’a pas encore de squelette (navigation sans rechargement), on l’injecte avant le fetch. */
  function ensureAvailabilitySkeletonBeforeFetch() {
    var dyn = document.getElementById('loven-dynamic-availability');
    var root = document.getElementById('CollectionAjaxResult');
    if (!dyn || !root) return;
    if (dyn.querySelector('.loven-dyn-grid--skeleton')) return;
    dyn.innerHTML = renderAvailabilitySkeletonHtml();
    dyn.hidden = false;
    root.classList.add('loven-dynamic-availability-mode');
  }

  function rowsToLocationsJson(rows) {
    var base = shopRoot().replace(/\/?$/, '');
    var locations = [];
    for (var i = 0; i < rows.length; i++) {
      var r0 = rows[i];
      if (!r0) continue;
      var r = normalizeAvailabilityRow(r0);
      if (!r.handle || !String(r.handle).trim()) continue;
      if (r.latitude == null || r.longitude == null) continue;
      var latN = Number(r.latitude);
      var lonN = Number(r.longitude);
      if (!isFinite(latN) || !isFinite(lonN)) continue;
      var amt = rowDisplayPriceAmount(r);
      var priceStr = amt != null ? formatPriceEurForGrid(amt) : '—';
      var url = base + '/products/' + encodeURIComponent(r.handle);
      locations.push({
        id: rowProductDomId(r, i),
        handle: (r.handle || '').trim(),
        lat: latN,
        lon: lonN,
        title: rowProductTitle(r),
        price: priceStr,
        thumbnail: getAvailabilityRowImageUrl(r),
        url: url,
        embedUrl: (r.embed_url || '').trim(),
        vendor: (r.vendor || '').trim(),
        productType: (r.product_type || r.productType || '').trim(),
        region: (r.region || '').trim(),
        ville: pickLocationField(r, ['ville_collection', 'ville', 'villeCollection', 'city']) || '',
        rating: rowRatingNumber(r),
        ratingCount: (function () {
          var rc = r.rating_count != null ? r.rating_count : r.ratingCount;
          var n = parseInt(String(rc), 10);
          return !isNaN(n) && n >= 0 ? n : null;
        })(),
      });
    }
    if (typeof window.LovenOffsetColocatedMapLocations === 'function') {
      window.LovenOffsetColocatedMapLocations(locations);
    }
    return { locations: locations };
  }

  var DYN_GRID_PAGE_SIZE = 24;

  function readDynGridPage() {
    try {
      var n = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
      return isNaN(n) || n < 1 ? 1 : n;
    } catch (e) {
      return 1;
    }
  }

  function dynGridPageHref(page) {
    var u = new URL(window.location.href);
    if (page <= 1) u.searchParams.delete('page');
    else u.searchParams.set('page', String(page));
    return u.pathname + u.search + u.hash;
  }

  function dynGridPaginationHtml(page, pages) {
    if (pages <= 1) return '';
    var html = '<nav class="loven-collection-pagination" aria-label="Pagination"><div class="pagination">';
    if (page > 1) {
      html +=
        '<span class="prev"><a href="' +
        dynGridPageHref(page - 1) +
        '" data-loven-dyn-page="' +
        (page - 1) +
        '" rel="prev">Précédent</a></span>';
    }
    var start = Math.max(1, page - 2);
    var end = Math.min(pages, page + 2);
    var n;
    if (start > 1) {
      html +=
        '<span class="page"><a href="' + dynGridPageHref(1) + '" data-loven-dyn-page="1">1</a></span>';
      if (start > 2) html += '<span class="page" aria-hidden="true">…</span>';
    }
    for (n = start; n <= end; n++) {
      if (n === page) html += '<span class="page current" aria-current="page">' + n + '</span>';
      else {
        html +=
          '<span class="page"><a href="' +
          dynGridPageHref(n) +
          '" data-loven-dyn-page="' +
          n +
          '">' +
          n +
          '</a></span>';
      }
    }
    if (end < pages) {
      if (end < pages - 1) html += '<span class="page" aria-hidden="true">…</span>';
      html +=
        '<span class="page"><a href="' +
        dynGridPageHref(pages) +
        '" data-loven-dyn-page="' +
        pages +
        '">' +
        pages +
        '</a></span>';
    }
    if (page < pages) {
      html +=
        '<span class="next"><a href="' +
        dynGridPageHref(page + 1) +
        '" data-loven-dyn-page="' +
        (page + 1) +
        '" rel="next">Suivant</a></span>';
    }
    html += '</div></nav>';
    return html;
  }

  function renderDynamicAvailabilityGrid(rows, pageOverride) {
    if (Array.isArray(rows)) window.__lovenDynGridSourceRows = rows;
    else rows = window.__lovenDynGridSourceRows || [];
    var root = document.getElementById('CollectionAjaxResult');
    var dyn = document.getElementById('loven-dynamic-availability');
    if (!dyn || !root) return;
    rememberSpicynessFromDom();
    var base = shopRoot().replace(/\/?$/, '');
    var parts = [];
    parts.push(
      '<div class="collection-grid__wrapper loven-dyn-grid"><div id="loven-dynamic-results-count" class="loven-collection-results-count loven-collection-results-count--map-sheet" data-server-count="0" aria-live="polite"><span class="loven-collection-results-count__title" role="status"></span></div>',
    );
    parts.push('<div class="new-grid product-grid collection-grid" data-view="large" data-scroll-to tabindex="-1">');
    var validRows = [];
    var vi;
    for (vi = 0; vi < rows.length; vi++) {
      var normalized = normalizeAvailabilityRow(rows[vi]);
      if (!normalized || !normalized.handle) continue;
      validRows.push({ row: normalized, index: vi });
    }
    var dynPages = Math.max(1, Math.ceil(validRows.length / DYN_GRID_PAGE_SIZE));
    var dynPage = pageOverride != null ? Number(pageOverride) : readDynGridPage();
    if (!isFinite(dynPage) || dynPage < 1) dynPage = 1;
    if (dynPage > dynPages) dynPage = dynPages;
    var showAll = dynPage <= 1;
    var dynStart = showAll ? 0 : (dynPage - 1) * DYN_GRID_PAGE_SIZE;
    var dynEnd = showAll
      ? Math.min(validRows.length, 250)
      : Math.min(validRows.length, dynStart + DYN_GRID_PAGE_SIZE);
    for (var si = dynStart; si < dynEnd; si++) {
      var r = validRows[si].row;
      var i = validRows[si].index;
      var pid = rowProductDomId(r, i);
      var href = base + '/products/' + encodeURIComponent(r.handle);
      var rawTitle = rowProductTitle(r);
      var title = escapeHtml(rawTitle);
      var latAttr = r.latitude != null ? ' data-map-lat="' + String(r.latitude) + '"' : '';
      var lonAttr = r.longitude != null ? ' data-map-lon="' + String(r.longitude) + '"' : '';
      var embedAttr = (r.embed_url || '').trim();
      var imgUrl = getAvailabilityRowImageUrl(r);
      var tertiaryHtml = formatLocationLineHtml(r);
      var locBlock = tertiaryHtml
        ? '<div class="grid-item__meta-tertiary loven-dyn-location">' + tertiaryHtml + '</div>'
        : '';
      var spiceLevel = rowSpicynessLevel(r);
      var spiceBlock = formatSpicynessCardHtml(spiceLevel);
      var spiceAttr = spiceLevel != null ? ' data-spicyness="' + String(spiceLevel) + '"' : '';
      var priceAmt = rowDisplayPriceAmount(r);
      var priceFormatted = priceAmt != null ? formatPriceEurForGrid(priceAmt) : '';
      var priceBlock = priceFormatted
        ? '<div class="grid-item__meta-secondary">' +
          '<div class="grid-product__price">' +
          '<span class="grid-product__price--current">' +
          '<span class="loven-grid-price-line" aria-hidden="true">À partir de ' +
          '<strong class="loven-grid-price-line__amount">' +
          priceFormatted +
          '</strong> <span class="loven-grid-price-line__period">/ nuit</span></span>' +
          '</span></div></div>'
        : '';
      var vendorBlock = (r.vendor || '').trim()
        ? '<div class="grid-product__vendor">' + escapeHtml(String(r.vendor).trim()) + '</div>'
        : '';
      var jdgmId = (r.id != null && String(r.id).trim() !== '' ? String(r.id).trim() : '') || '';
      var avisCountHtml = formatRatingAvisCountHtml(r);
      var jdgmBlock;
      if (jdgmId) {
        /* Même gabarit que `product-grid-item.liquid` (Judge.me) + rating_count (API) à droite. */
        jdgmBlock =
          '<div class="loven-dyn-rating-wrap">' +
          '<div style="" class="jdgm-widget jdgm-preview-badge" data-id="' +
          escapeHtml(jdgmId) +
          '" data-auto-install="false"></div>' +
          avisCountHtml +
          '</div>';
      } else {
        var ratingNum = rowRatingNumber(r);
        if (ratingNum != null && ratingNum > 0) {
          var nr = Math.min(5, Math.round(ratingNum));
          var stars = '';
          var starI;
          for (starI = 0; starI < nr; starI++) {
            stars += '\u2605';
          }
          jdgmBlock =
            '<div class="loven-dyn-rating-wrap loven-dyn-rating-wrap--stars">' +
            '<div class="loven-dyn-rating" aria-hidden="true">' +
            stars +
            '</div>' +
            avisCountHtml +
            '</div>';
        } else if (avisCountHtml) {
          jdgmBlock = '<div class="loven-dyn-rating-wrap">' + avisCountHtml + '</div>';
        } else {
          /* Pas d’avis : 5 étoiles vides (repli sans Judge.me) */
          jdgmBlock =
            '<div class="loven-dyn-rating-wrap loven-dyn-rating-wrap--stars">' +
            '<div class="loven-dyn-rating loven-dyn-rating--empty" aria-hidden="true">' +
            fiveEmptyStarsString() +
            '</div>' +
            '</div>';
        }
      }
      var cardIndex = si - dynStart;
      var imageLoading = dynPage <= 1 && cardIndex < 4 ? 'eager' : 'lazy';
      var imagePriority = '';
      if (dynPage <= 1 && cardIndex === 0) imagePriority = ' fetchpriority="high"';
      var imageBlock = imgUrl
        ? '<div class="grid__image-ratio grid__image-ratio--landscape">' +
          '<img src="' +
          escapeHtml(imgUrl) +
          '" alt="' +
          title +
          '" class="grid-product__image grid-product__image--eager" loading="' +
          imageLoading +
          '"' +
          imagePriority +
          ' decoding="async" width="600" height="450" sizes="(min-width: 1200px) 25vw, (min-width: 990px) 33vw, (min-width: 600px) 50vw, 100vw" />' +
          '</div>'
        : '<div class="grid__image-ratio grid__image-ratio--landscape">' +
          '<div class="loven-dyn-grid__placeholder" aria-hidden="true"></div>' +
          '</div>';
      parts.push(
        '<div class="grid-item grid-product loven-grid-card" data-product-id="' +
          escapeHtml(pid) +
          '" data-product-handle="' +
          escapeHtml(r.handle || '') +
          '" data-bookingmood-embed-url="' +
          escapeHtml(embedAttr) +
          '"' +
          latAttr +
          lonAttr +
          spiceAttr +
          '><div class="grid-item__content"><a href="' +
          escapeHtml(href) +
          '" class="grid-item__link" title="' +
          title +
          '"><div class="grid-product__image-wrap">' +
          imageBlock +
          '</div><div class="grid-item__meta"><div class="grid-item__meta-main">' +
          locBlock +
          '<div class="h5 grid-product__title">' +
          title +
          '</div>' +
          spiceBlock +
          jdgmBlock +
          vendorBlock +
          '</div>' +
          priceBlock +
          '</div></a></div></div>',
      );
    }
    parts.push('</div>');
    if (!showAll) parts.push(dynGridPaginationHtml(dynPage, dynPages));
    parts.push('</div>');
    dyn.innerHTML = parts.join('');
    dyn.hidden = false;
    root.classList.add('loven-dynamic-availability-mode');
    window.__lovenDynamicAvailabilityMode = true;
    updateResultsCountHeading();
  }

  window.LovenRenderDynamicGridPage = function (page) {
    renderDynamicAvailabilityGrid(window.__lovenDynGridSourceRows || [], page);
    if (typeof window.LovenPaintSponsoredBadges === 'function') window.LovenPaintSponsoredBadges();
    if (typeof window.LovenBoostSponsoredGrid === 'function') window.LovenBoostSponsoredGrid({ force: true });
    var grid = document.querySelector('#loven-dynamic-availability .product-grid');
    if (grid) {
      try {
        grid.focus({ preventScroll: true });
      } catch (err) {
        grid.focus();
      }
    }
  };

  function insertFacetNotice() {
    if (LOVEN_HIDE_SHOPIFY_FACET_COUNTS) return;
    var sidebar = document.getElementById('CollectionSidebar');
    if (!sidebar || sidebar.querySelector('.loven-facet-counts-notice')) return;
    var wrap = sidebar.querySelector('.filter-wrapper');
    if (!wrap) return;
    var div = document.createElement('div');
    div.className = 'loven-facet-counts-notice';
    div.setAttribute('role', 'note');
    div.style.cssText =
      'font-size:0.85em;line-height:1.35;color:#444;margin-bottom:12px;padding:10px 12px;background:#fffbeb;border:1px solid #fde68a;border-radius:8px;';
    div.textContent =
      'Les nombres entre parenthèses correspondent aux facettes Shopify (Search & Discovery), pas à la disponibilité aux dates choisies.';
    wrap.parentNode.insertBefore(div, wrap);
  }

  function fallbackToStaticCollectionGrid() {
    removeAvailabilityDebugPanel();
    clearDynamicAvailability();
    window.__lovenZoneCollectionGeoBrowse = false;
    window.__lovenAvailabilityTotal = undefined;
    window.__lovenAvailabilityVisible = undefined;
    window.__lovenAvailabilityApiRows = undefined;
    window.__lovenAvailabilityApiEnvelope = undefined;
    window.__lovenAvailabilityByEmbedKey = undefined;
    if (isNamedCollectionCatalogPage()) {
      restoreStaticCollectionGrid();
    } else {
      document.querySelectorAll('#CollectionAjaxContent .grid-product[data-product-id]').forEach(function (card) {
        card.style.removeProperty('display');
      });
    }
    if (typeof window.LovenCollectionDestFilterRun === 'function') {
      window.LovenCollectionDestFilterRun();
    }
    if (typeof window.LovenUpdateFilterModalFooter === 'function') {
      window.LovenUpdateFilterModalFooter();
    } else {
      updateResultsCountHeading();
    }
    document.dispatchEvent(new CustomEvent('collection:mapSync'));
    if (typeof window.LovenBoostSponsoredGrid === 'function') {
      requestAnimationFrame(function () {
        window.LovenBoostSponsoredGrid({ force: true });
      });
    }
  }

  function processSearchAvailabilityResponse(data, requestKind, facetSet) {
    var isCatalogMapRequest = requestKind === 'catalog_map' || requestKind === 'catalog_map_retry';
    var isGeoOnlyRequest = requestKind === 'geo' || requestKind === 'geo_map_expand' || isCatalogMapRequest;
    if (requestKind === 'geo_map_expand' && isZoneCollectionGeoBrowse()) {
      window.__lovenZoneCollectionGeoBrowse = true;
    }
    var envelope = getAvailabilityEnvelope(data);
    var extracted = extractAvailabilityRowsFromPayload(data);
    if (extracted.length === 0 && isLovenListDebug() && isGeoOnlyRequest) {
      try {
        console.warn(
          '[Loven] Aucun tableau d’hébergements extrait. Clés racine :',
          data && typeof data === 'object' && !Array.isArray(data) ? Object.keys(data) : [],
          '— (aligner l’API sur `available` / `response.available`, etc.)',
        );
      } catch (e) {}
    }
    var rowsAfterNorm = extracted.map(normalizeAvailabilityRow);
    var nBeforeStatus = rowsAfterNorm.length;
    var rowsNormalized = rowsAfterNorm.filter(function (row) {
      return !isAvailabilityRowHiddenByProductStatus(row);
    });
    if (isLovenListDebug() && nBeforeStatus > rowsNormalized.length) {
      try {
        console.info(
          '[Loven] Lignes exclues (statut draft / archived / unlisted) :',
          nBeforeStatus - rowsNormalized.length,
        );
      } catch (e) {}
    }
    var rowsBeforeRadius = rowsNormalized.length;
    /* Mode geo : le rayon est déjà appliqué côté API — re-filtrer ici supprime souvent tout (coords Accentuate / ordre lat-lon). */
    var rows = isGeoOnlyRequest ? rowsNormalized : filterAvailabilityRowsByDestRadius(rowsNormalized);
    rows = filterRowsToZoneCollectionCatalog(rows, requestKind);
    if (
      !isLovenConsoleDebugForAvailability() &&
      !isGeoOnlyRequest &&
      rowsBeforeRadius > 0 &&
      rows.length === 0 &&
      readDestSearchFromUrl()
    ) {
      console.warn(
        '[Loven dispo] 0 ligne après filtre rayon (dest_lat / dest_lon / dest_radius_km). Élargir le rayon ou retirer la zone sur la carte.',
      );
    }
    if (isLovenConsoleDebugForAvailability()) {
      try {
        console.log(JSON.stringify(data, null, 2));
      } catch (e) {
        console.log(data);
      }
    }

    /* Love'nSpa 16/10/2026 : facettes Shopify (filter.*) appliquées aux lignes API (search uniquement :
       les collections nommées gardent la grille Shopify native). Le total « disponibles » reste
       celui d'avant facettes pour proposer « Voir tous les hébergements disponibles » si 0 résultat. */
    var rowsBeforeFacets = rows;
    var facetsApplied = false;
    if (facetSet && facetSet.handles && !isNamedCollectionCatalogPage()) {
      rows = filterRowsByFacetHandles(rows, facetSet);
      facetsApplied = true;
      if (isLovenListDebug() || isLovenConsoleDebugForAvailability()) {
        try {
          console.info(
            '[Loven] Facettes sur grille API :',
            rowsBeforeFacets.length,
            '→',
            rows.length,
            'lignes (' + facetSet.count + ' handles Shopify' + (facetSet.truncated ? ', tronqué' : '') + ')',
          );
        } catch (e) {}
      }
    }

    window.__lovenAvailabilityApiEnvelope = envelope;
    window.__lovenAvailabilityApiRows = rows;
    window.__lovenAvailabilityByEmbedKey = {};
    rows.forEach(function (row) {
      var k = normalizeBookingmoodEmbedKey(row.embed_url);
      if (k) window.__lovenAvailabilityByEmbedKey[k] = row;
    });

    /* La grille statique est déjà filtrée par Shopify : on la croise avec la dispo d'avant facettes. */
    var availableUrls = rowsBeforeFacets.map(function (p) {
      return p.embed_url;
    });
    var uniqueUrls = {};
    availableUrls.forEach(function (u) {
      var k = normalizeBookingmoodEmbedKey(u);
      if (k) uniqueUrls[k] = true;
    });
    var totalUnique = Object.keys(uniqueUrls).length;
    if (totalUnique === 0 && rowsBeforeFacets.length > 0) {
      totalUnique = rowsBeforeFacets.length;
    }

    window.__lovenAvailabilityTotal = totalUnique;

    try {
      var lastReq = window.__lovenLastSearchAvailabilityRequest;
      if (lastReq && lastReq.body) {
        rememberMapActiveGeoFromBody(lastReq.body);
      }
    } catch (e) {}

    /* Collections nommées (/collections/bretagne, etc.) : catalogue Shopify, pas de grille API. */
    if (isNamedCollectionCatalogPage() && isGeoOnlyRequest && !isCatalogMapRequest) {
      clearDynamicAvailability();
      restoreStaticCollectionGrid();
      if (typeof window.LovenCollectionDestFilterRun === 'function') {
        window.LovenCollectionDestFilterRun();
      }
      syncModalFooterAvailability(totalUnique, window.__lovenAvailabilityVisible);
      document.dispatchEvent(new CustomEvent('collection:mapSync'));
      return;
    }

    var dyn = document.getElementById('loven-dynamic-availability');
    var useDynamic = !!dyn;
    if (useDynamic) {
      if (isNamedCollectionCatalogPage()) {
        useDynamic = false;
      } else if (isGeoOnlyRequest) {
        useDynamic = true;
      } else {
        /* Décision sur les lignes d'avant facettes : 0 résultat après facettes doit rester
           une grille API vide (« Aucun hébergement ne correspond à ces filtres »), pas la grille statique. */
        useDynamic = rowsBeforeFacets.length > 0 && shouldUseDynamicAvailability(envelope, rowsBeforeFacets);
      }
    }

    if (isCatalogMapRequest) {
      var catalogLocJson = rowsToLocationsJson(rows);
      if (
        !catalogLocJson.locations.length &&
        envelope &&
        typeof envelope.enriched_count === 'number' &&
        envelope.enriched_count > 0
      ) {
        if (isLovenListDebug() || isLovenConsoleDebugForAvailability()) {
          try {
            console.warn(
              '[Loven] Carte catalogue — available[] vide mais enriched_count=' +
                envelope.enriched_count +
                ' (souvent dest_lat/dest_lon inversés). Repli centre France.',
            );
          } catch (e) {}
        }
        var fr = mapDataCenterAttrsToWgs84(null, null);
        return fetchSearchAvailabilityWithPayload(
          { dest_lat: fr.lat, dest_lon: fr.lon, dest_radius_km: 500 },
          'catalog_map_retry',
        );
      }
      if (!catalogLocJson.locations.length) {
        window.__lovenCatalogMapFromApi = false;
        if (isLovenListDebug() || isLovenConsoleDebugForAvailability()) {
          try {
            console.warn('[Loven] Carte catalogue — 0 pin API, conservation du JSON Liquid.');
          } catch (e) {}
        }
        document.dispatchEvent(new CustomEvent('collection:mapSync'));
        return;
      }
      window.__lovenCatalogMapFromApi = true;
      if (isLovenListDebug() || isLovenConsoleDebugForAvailability()) {
        try {
          console.info(
            '[Loven] Carte catalogue —',
            catalogLocJson.locations.length,
            'pins (grille statique inchangée)',
          );
        } catch (e) {}
      }
      requestAnimationFrame(function () {
        if (typeof window.LovenCollectionMapApplyLocationsJson === 'function') {
          window.LovenCollectionMapApplyLocationsJson(catalogLocJson);
        }
        document.dispatchEvent(new CustomEvent('collection:mapSync'));
      });
      return;
    }

    if (useDynamic) {
      window.__lovenDynamicAvailabilityMode = true;
      var skipSponsoredRefresh =
        requestKind === 'geo_map_expand' && isZoneCollectionGeoBrowse();
      if (!skipSponsoredRefresh && typeof window.LovenRefreshSponsoredFromRegistry === 'function') {
        window.LovenRefreshSponsoredFromRegistry();
      }
      if (typeof window.LovenReorderAvailabilityRowsForSponsored === 'function') {
        rows = window.LovenReorderAvailabilityRowsForSponsored(rows);
      }
      window.__lovenAvailabilityVisible = rows.length;
      renderDynamicAvailabilityGrid(rows);
      if (!skipSponsoredRefresh && typeof window.LovenRefreshSponsoredFromRegistry === 'function') {
        window.LovenRefreshSponsoredFromRegistry();
      }
      if (typeof window.LovenBoostSponsoredGrid === 'function') {
        requestAnimationFrame(function () {
          window.LovenBoostSponsoredGrid({ force: true });
        });
      }
      var locJson = rowsToLocationsJson(rows);
      logAvailabilityListDiagnostic(rows);
      requestAnimationFrame(function () {
        if (typeof window.LovenCollectionMapApplyLocationsJson === 'function') {
          window.LovenCollectionMapApplyLocationsJson(locJson);
        }
        document.dispatchEvent(new CustomEvent('collection:mapSync'));
        var mapRef = window.__lovenCollectionLeafletMap;
        var ajaxRoot = document.getElementById('CollectionAjaxResult');
        var isMobileMap =
          ajaxRoot &&
          ajaxRoot.classList.contains('loven-collection-map-mobile') &&
          typeof window.matchMedia === 'function' &&
          window.matchMedia('(max-width: 768px)').matches;
        if (
          !isMobileMap &&
          mapRef &&
          typeof window.LovenRunMapViewportGridPipeline === 'function'
        ) {
          window.LovenRunMapViewportGridPipeline(mapRef, { silent: true, skipFetch: true });
        } else if (isMobileMap && typeof window.LovenClearMapViewportGridFilter === 'function') {
          window.LovenClearMapViewportGridFilter();
        }
      });
      syncModalFooterAvailability(totalUnique, rows.length);
      document.dispatchEvent(
        new CustomEvent('collection:availability', {
          detail: {
            total: totalUnique,
            visible: rows.length,
            mapGeoExpand: requestKind === 'geo_map_expand',
          },
        }),
      );
      return;
    }

    clearDynamicAvailability();

    var shown = applyAvailabilityFilterToStaticGrid(uniqueUrls);

    syncModalFooterAvailability(totalUnique, shown);
    document.dispatchEvent(
      new CustomEvent('collection:availability', { detail: { total: totalUnique, visible: shown } }),
    );
    document.dispatchEvent(new CustomEvent('collection:mapSync'));
  }

  function fetchSearchAvailabilityWithPayload(body, requestKind) {
    var isCatalogMap = requestKind === 'catalog_map' || requestKind === 'catalog_map_retry';
    var isGeoOnly = requestKind === 'geo' || isCatalogMap;
    if (!isCatalogMap && requestKind !== 'geo_map_expand') {
      ensureAvailabilitySkeletonBeforeFetch();
    }
    try {
      window.__lovenLastSearchAvailabilityRequest = {
        url: API_URL,
        kind: requestKind,
        body: body,
        at: new Date().toISOString(),
      };
    } catch (e) {}

    if (isGeoOnly && (isLovenListDebug() || isLovenConsoleDebugForAvailability())) {
      console.info(
        '%c[Loven] POST search-availability (' +
          requestKind +
          ')' +
          (window.__lovenZoneCollectionGeoBrowse ? ' [collection zone]' : ''),
        'font-weight:bold',
        body,
      );
    }

    /* Facettes Shopify chargées en parallèle de l'API (null sans facette active). */
    var facetPromise = loadFacetHandlesForCurrentUrl();

    var apiPromise = fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          try {
            console.warn('[Loven] search-availability HTTP ' + r.status, data);
          } catch (e) {}
          var err = new Error('search-availability ' + (r.status || 'error'));
          err.__lovenPayload = body;
          err.__lovenResponse = data;
          throw err;
        }
        return data;
      });
    });

    return Promise.all([apiPromise, facetPromise]).then(function (results) {
      processSearchAvailabilityResponse(results[0], requestKind, results[1]);
    });
  }

  window.LovenCollectionAvailabilityFilterRun = function () {
    removePreviousUi();

    if (isNamedCollectionCatalogPage()) {
      runNamedCollectionCatalogBrowse();
      return;
    }

    var payload = buildSearchAvailabilityRequestPayload();
    window.__lovenZoneCollectionGeoBrowse = !!(payload && payload.kind === 'geo' && isZoneCollectionGeoBrowse());

    if (!payload) {
      /* Pas d’appel API : search catalogue global, ou collection sans carte. */
      removeAvailabilityDebugPanel();
      clearDynamicAvailability();
      window.__lovenCatalogMapFromApi = false;
      window.__lovenZoneCollectionGeoBrowse = false;
      window.__lovenAvailabilityTotal = undefined;
      window.__lovenAvailabilityVisible = undefined;
      window.__lovenAvailabilityApiRows = undefined;
      window.__lovenAvailabilityApiEnvelope = undefined;
      window.__lovenAvailabilityByEmbedKey = undefined;
      if (isNamedCollectionCatalogPage()) {
        restoreStaticCollectionGrid();
      } else {
        document.querySelectorAll('#CollectionAjaxContent .grid-product[data-product-id]').forEach(function (card) {
          card.style.removeProperty('display');
        });
      }
      if (typeof window.LovenCollectionDestFilterRun === 'function') {
        window.LovenCollectionDestFilterRun();
      }
      if (typeof window.LovenUpdateFilterModalFooter === 'function') {
        window.LovenUpdateFilterModalFooter();
      } else {
        updateResultsCountHeading();
      }
      if (typeof window.LovenBoostSponsoredGrid === 'function') {
        requestAnimationFrame(function () {
          window.LovenBoostSponsoredGrid({ force: true });
        });
      }
      return;
    }

    if (payload.kind === 'catalog_map') {
      clearDynamicAvailability();
      window.__lovenCatalogMapFromApi = false;
      var catalogFetchStarted = false;
      function runCatalogMapFetchOnce() {
        if (catalogFetchStarted) return;
        catalogFetchStarted = true;
        return fetchSearchAvailabilityWithPayload(payload.body, 'catalog_map').catch(function (err) {
          window.__lovenCatalogMapFromApi = false;
          if (isLovenListDebug() || isLovenConsoleDebugForAvailability()) {
            console.warn(
              '[Loven] Carte catalogue : API en erreur — repli JSON Liquid. Inspecter window.__lovenLastSearchAvailabilityRequest',
              err && err.__lovenResponse,
            );
          }
          if (
            window.__lovenCollectionMapLiquidBackup &&
            typeof window.LovenCollectionMapApplyLocationsJson === 'function'
          ) {
            window.LovenCollectionMapApplyLocationsJson(window.__lovenCollectionMapLiquidBackup);
          } else if (typeof window.LovenCollectionMapInit === 'function') {
            window.LovenCollectionMapInit();
          }
          if (typeof window.LovenCollectionDestFilterRun === 'function') {
            window.LovenCollectionDestFilterRun();
          }
          document.dispatchEvent(new CustomEvent('collection:mapSync'));
        });
      }
      if (window.__lovenCollectionLeafletMap) {
        return runCatalogMapFetchOnce();
      }
      document.addEventListener('loven:collection-map-ready', runCatalogMapFetchOnce, { once: true });
      setTimeout(runCatalogMapFetchOnce, 1200);
      return;
    }

    if (payload.kind === 'geo') {
      if (isNamedCollectionCatalogPage()) {
        clearDynamicAvailability();
        restoreStaticCollectionGrid();
        if (typeof window.LovenCollectionDestFilterRun === 'function') {
          window.LovenCollectionDestFilterRun();
        }
        if (typeof window.LovenUpdateFilterModalFooter === 'function') {
          window.LovenUpdateFilterModalFooter();
        } else {
          updateResultsCountHeading();
        }
        document.dispatchEvent(new CustomEvent('collection:mapSync'));
        if (typeof window.LovenBoostSponsoredGrid === 'function') {
          requestAnimationFrame(function () {
            window.LovenBoostSponsoredGrid({ force: true });
          });
        }
        return;
      }
      window.__lovenCatalogMapFromApi = false;
      window.__lovenAvailabilityTotal = undefined;
      window.__lovenAvailabilityVisible = undefined;
      window.__lovenAvailabilityApiRows = undefined;
      window.__lovenAvailabilityApiEnvelope = undefined;
      window.__lovenAvailabilityByEmbedKey = undefined;
      return fetchSearchAvailabilityWithPayload(payload.body, 'geo').catch(function (err) {
        if (isLovenListDebug() || isLovenConsoleDebugForAvailability()) {
          console.warn(
            '[Loven] Mode geo : API en erreur — repli grille statique. Inspecter window.__lovenLastSearchAvailabilityRequest',
            err && err.__lovenResponse,
          );
        }
        fallbackToStaticCollectionGrid();
      });
    }

    window.__lovenCatalogMapFromApi = false;
    document.body.classList.add('loven-collection-dates-active');
    insertFacetNotice();
    return fetchSearchAvailabilityWithPayload(payload.body, 'availability').catch(function () {
      removeAvailabilityDebugPanel();
      clearDynamicAvailability();
      window.__lovenAvailabilityTotal = undefined;
      window.__lovenAvailabilityVisible = undefined;
      window.__lovenAvailabilityApiRows = undefined;
      window.__lovenAvailabilityApiEnvelope = undefined;
      window.__lovenAvailabilityByEmbedKey = undefined;
      if (typeof window.LovenUpdateFilterModalFooter === 'function') {
        window.LovenUpdateFilterModalFooter();
      } else {
        updateResultsCountHeading();
      }
      document.dispatchEvent(new CustomEvent('collection:mapSync'));
    });
  };

  window.LovenIsNamedCollectionCatalogPage = isNamedCollectionCatalogPage;
  window.LovenRunNamedCollectionCatalogBrowse = runNamedCollectionCatalogBrowse;

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-loven-dyn-page]') : null;
    if (!a) return;
    e.preventDefault();
    var page = parseInt(a.getAttribute('data-loven-dyn-page'), 10);
    if (!page) return;
    try {
      var next = new URL(a.href, window.location.origin);
      history.pushState({}, '', next.pathname + next.search + next.hash);
    } catch (err) {}
    window.LovenRenderDynamicGridPage(page);
    if (typeof window.LovenScrollCollectionGridToTop === 'function') window.LovenScrollCollectionGridToTop();
  });

  document.addEventListener('DOMContentLoaded', function () {
    rememberSpicynessFromDom();
    hideCollectionFacetCounts();
    bindModalFooterOnce();
    window.LovenCollectionAvailabilityFilterRun();
  });
  document.addEventListener('collection:reloaded', function () {
    hideCollectionFacetCounts();
    window.LovenCollectionAvailabilityFilterRun();
  });

  document.addEventListener('loven:collection-map-ready', function () {
    if (isNamedCollectionCatalogPage()) {
      runNamedCollectionCatalogBrowse();
    }
  });

  /**
   * Centre + rayon pour éligibilité sponsorisée (search dest_* ou collection zone geo).
   */
  window.LovenGetCollectionGeoDest = function () {
    var dest = readDestSearchFromUrl();
    if (dest) return dest;
    if (!window.__lovenZoneCollectionGeoBrowse && !isZoneCollectionGeoBrowse()) return null;
    var body = buildZoneCollectionGeoBody();
    return {
      lat: body.dest_lat,
      lng: body.dest_lon,
      radiusKm: body.dest_radius_km,
    };
  };

  window.LovenSeedZoneCollectionActiveGeo = function () {
    if (!isZoneCollectionGeoBrowse()) return;
    if (window.__lovenMapActiveGeoRadiusKm != null && window.__lovenMapActiveGeoCenter) return;
    rememberMapActiveGeoFromBody(buildZoneCollectionGeoBody());
  };

  window.LovenIsZoneCollectionGeoBrowse = isZoneCollectionGeoBrowse;

  window.LovenNormalizeBookingmoodEmbedKey = normalizeBookingmoodEmbedKey;
  window.LovenDynamicAvailabilityClear = clearDynamicAvailability;
  window.LovenRemoveAvailabilityDebugPanel = removeAvailabilityDebugPanel;
})();
